<template>
  <div class="driver-route">
    <DriverShortestRouteMap
      v-if="commerceOrder"
      :commerceOrder="commerceOrder"
      @close="goBack"
    />
    <div v-if="!commerceOrder" class="loading" @click="goHome">
      Loading Route...
    </div>
  </div>
</template>

<script>
// import photos from "@/photos";

import DriverShortestRouteMap from "@/components/DriverShortestRouteMap.vue";

export default {
  name: "DriverRoute",
  components: { DriverShortestRouteMap },
  props: {
    id: String,
  },
  data() {
    return {
      commerceOrder: null,
    };
  },
  computed: {},
  mounted() {
    if (!this.isSuperUser()) this.goHome(); // superuser only
    console.log("commerceOrderID", this.id);
    this.getCommerceOrder();
  },
  methods: {
    getCommerceOrder() {
      this.$store
        .dispatch("getCommerceOrder", this.id)
        .then((res) => (this.commerceOrder = res.data))
        .catch((err) => this.apiError(err));
    },
    goBack() {
      this.$router.go(-1); // go back
    },
  },
};
</script>

<style scoped>
.driver-route {
  background-color: #333;
  height: 100vh;
  width: 100vw;
}
.loading {
  padding: 30px;
  color: white;
}
</style>
